import { devMode } from '../../util/env'
import { buildQueryString } from '../../util/string'
import { NONCE } from '../../shared/constants'

export const SUBMIT = 'ksk001/unlockEstateAddress/SUBMIT'
export const SUBMIT_SUCCESS = 'ksk001/unlockEstateAddress/SUBMIT_SUCCESS'
export const SUBMIT_FAILURE = 'ksk001/unlockEstateAddress/SUBMIT_FAILURE'

export const initialState = {
  error: false,
  success: false,
  isSubmitting: false,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SUBMIT:
      return {
        ...state,
        isSubmitting: true,
        error: false,
      }
    case SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: payload.success,
      }
    case SUBMIT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const submit = formdata => (dispatch, getState) => {
  const state = getState()
  const id = state.estatePage.estateData.id

  const query = buildQueryString({ ...formdata, id })

  dispatch({
    type: SUBMIT,
  })

  return fetch(`/wp-json/dhsv/v1/user/unlock-estate-address?${query}`, {
    headers: {
      'X-WP-Nonce': NONCE,
    },
  })
    .then(response => {
      if (![200, 400].includes(response.status)) {
        const message = response.statusText
          ? response.status + ': ' + response.statusText
          : response.status

        throw new Error(message)
      }

      return response.json().then(json => {
        if ('success' in json) {
          dispatch({
            type: SUBMIT_SUCCESS,
            payload: {
              success: json.success,
            },
          })

          setTimeout(() => {
            location.reload()
          }, 3000)
        }

        return json
      })
    })
    .catch(error => {
      if (devMode) console.error(error) //eslint-disable-line
      dispatch({
        payload: {
          error: error.message,
        },
        type: SUBMIT_FAILURE,
      })
      throw error
    })
}
